import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider, Button, FloatButton, theme } from 'antd';
import 'antd/dist/reset.css';
import Routes from './Routes/Routes';
import './App.css';

import './components/Forms/darkThemeExtra.css';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('globalDarkMode') === 'true';
  });

  useEffect(() => {
    document.body.classList.toggle('add-services-dark', darkMode);
    localStorage.setItem('globalDarkMode', darkMode);
  }, [darkMode]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#41b06e',
          colorSuccess: '#52c41a',
          colorWarning: '#faad14',
          colorError: '#ff4d4f',
          borderRadius: 6,
          colorBgBase: darkMode ? '#18191a' : '#fff',
          colorTextBase: darkMode ? '#e4e6eb' : '#000',
        },
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <Router>
        <Routes />
        <FloatButton
          icon={darkMode ? <span role="img" aria-label="Hell">🌞</span> : <span role="img" aria-label="Dunkel">🌙</span>}
          type="primary"
          style={{ right: 24, bottom: 24, zIndex: 1000 }}
          tooltip={darkMode ? 'Wechsel zu hellem Modus' : 'Wechsel zu dunklem Modus'}
          onClick={() => setDarkMode((prev) => !prev)}
        />
      </Router>
    </ConfigProvider>
  );
}

export default App;
